import {request, serviceUrl} from "@/utils/request";

// 分页获取机柜设备列表
export function cabinetPage(equipmentCabinetDto) {
  return request({
    params: equipmentCabinetDto,
    url: serviceUrl.deviceService + "/equipment/cabinet/page",
    method: 'get',
  })
}

// 保存机柜信息
export function saveCabinet(cabinetInfo) {
  return request({
    data: cabinetInfo,
    url: serviceUrl.deviceService + "/equipment/cabinet/save",
    method: 'post',
  })
}

// 编辑机柜信息
export function updateCabinet(cabinetInfo) {
  return request({
    data: cabinetInfo,
    url: serviceUrl.deviceService + "/equipment/cabinet/update",
    method: 'post',
  })
}

// 根据机柜id删除机柜信息
export function delCabinetById(id) {
  return request({
    params: {id},
    url: serviceUrl.deviceService + "/equipment/cabinet/deleteById",
    method: 'get',
  })
}

// 根据空间id 查询
export function getBySpaceId(spaceId) {
  return request({
    params: {spaceId},
    url: serviceUrl.deviceService + "/equipment/cabinet/getBySpaceId",
    method: 'get',
  })
}

// 根据空间id 查询数据
export function getPowerBySpaceId(spaceId) {
  return request({
    params: {spaceId},
    url: serviceUrl.deviceService + "/equipment/cabinet/getPowerBySpaceId",
    method: 'get',
  })
}

// 导出机柜报表
export function cabinetToExcel(startDateTime, endDateTime) {
  return request({
    url: serviceUrl.deviceService + '/equipment/cabinet/export?startDateTime=' + startDateTime + '&endDateTime=' + endDateTime,
    method: 'post',
    timeout: 60 * 20 * 1000
  })
}



